import bugsnagClient from './bugsnag';

export function reportError(error, metadata = {}) {
  if (!bugsnagClient) return;

  bugsnagClient.notify(error, { metaData: metadata });
}
